(function () {


	angular.module('app.widgets')
	.directive('plaEnter', plaEnter); 

	function plaEnter() {
		return function(scope,element,attrs){
			element.bind("keydown keypress",function(event){
				if(event.which===13){
					event.preventDefault();
					var fields=$(this).parents('.detalle').find('input, textarea, select');
					var index=fields.index(this);
					if(index> -1&&(index+1)<fields.length)
						fields.eq(index+1).focus().select();
				}
			});
		};
    }

})();